import { apiHelpers } from './api';
import { ApiResponse, EmployeeDocumentsResponse } from '../types/models';

export class AllDocumentsService {
  // Получить все документы сотрудника
  static async getAllByEmployee(employeeId: number): Promise<ApiResponse<EmployeeDocumentsResponse>> {
    return apiHelpers.get<EmployeeDocumentsResponse>(`/AllDocuments/GetAll?employeeId=${employeeId}`);
  }
}

